module.exports = __webpack_public_path__ + "static/media/apply-agent-available.ecad5868.svg";